<template lang="pug">
.dropdown-menu(v-if="displayCitation")
  .dropdown-content.content
    .dropdown-item
      p.has-text-weight-bold {{ $t("citation.recommendation") }}
    hr.dropdown-divider
    .dropdown-item
      p(v-html="citationText")
</template>

<script>
const { formatStrikethrough } = require("../filters/formatStrikeThrough");
const { messages } = require("../i18n/citation");
const { mapGetters, mapState } = require("vuex");

export default {
    name: "Citation",
    i18n: { messages },
    computed: {

        citationText() {
            return `Walter Benjamin: ${formatStrikethrough(this.current.title)} [${this.current.sig}]. ${this.$t("citation.in")}: ${this.$t("citation.title")}.
                ${this.fullUrl} [${this.$t("citation.accessed")} ${this.$d(new Date(), "short")} ]`;
        },

        fullUrl() {
            return window.location.origin + this.$route.fullPath;
        },

        ...mapGetters("toc", ["current"]),
        ...mapState("transcript", ["eventBus", "displayCitation"])
    }
}
</script>